// ResponsiveBrands.jsx → src/gestion-brands/
import React from "react";
import Brands from "./Brands";
import BrandsMobile from "../mobile/produits/BrandsMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveBrands(props) {
  return useIsMobile() ? <BrandsMobile {...props} /> : <Brands {...props} />;
}
